module.exports = __webpack_public_path__ + "img/header-diamondJewelryCollectionRings.b7c1970.jpg";